import Plus from "../../assets/icon/plus.svg";

const NewItemButton = ({ itemName, setShowPopUp, setMethod = () => {} }) => {
  const onClick = () => {
    setShowPopUp(true);
    setMethod("POST");
  };

  return (
    <div
      className="flex items-center ml-12 mb-0 hover:brightness-75 gap-x-1 cursor-pointer"
      onClick={onClick}
    >
      <img
        src={Plus}
        alt="plus sign"
        className="w-8 h-8  custom-brown-filter"
      />
      <button className="text-dark-text font-bold text-2xl">
        新增{itemName}
      </button>
    </div>
  );
};

export default NewItemButton;
